module.exports = __webpack_public_path__ + "static/media/carousel1.3f6de60d.png";